// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--c98e6";
export var screen1__container = "style-module--screen1__container--ca2ff";
export var screen1__imgContainer = "style-module--screen1__img-container--88b40";
export var screen1__link = "style-module--screen1__link--9228d";
export var screen1__linkWrapper = "style-module--screen1__link-wrapper--192b7";
export var screen1__subtitle = "style-module--screen1__subtitle--1f664";
export var screen1__title = "style-module--screen1__title--12f0d";
export var screen1__titleWrapper = "style-module--screen1__title-wrapper--a6510";